import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the AddMemberProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AddMemberProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello AddMemberProvider Provider');
  }

  getChatroomList(keyword,page,pagesize){
    let params = {
      keyword:keyword,
      page:page,
      pagesize:pagesize
    }
    return this.http.hPost('/contentdetect/get_chatrooms_by_keyword',params);
  }

  getMemberList(chatroom_id,keyword,page,pagesize){
    let params = {
      chatroomname:chatroom_id,
      keyword:keyword,
      page:page,
      pagesize:pagesize
    }
    return this.http.hPost('/contentdetect/get_members_by_keyword',params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/add-member/add-member.ts